import { render, staticRenderFns } from "./CategoryArticle.vue?vue&type=template&id=3f773609&scoped=true"
import script from "./CategoryArticle.vue?vue&type=script&lang=js"
export * from "./CategoryArticle.vue?vue&type=script&lang=js"
import style0 from "./CategoryArticle.vue?vue&type=style&index=0&id=3f773609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f773609",
  null
  
)

export default component.exports